import React, {Component} from 'react';
import styled from 'styled-components'
import {Backdrop, Block, Divider, Overlay, Portal} from "reakit";
import {Box, Flex, Heading, Image, Text} from 'rebass';

import chevronRight from '../../resources/img/icons/Chevron_2@1x.png'
import chevron from '../../resources/img/icons/Chevron@1x.png'
import check from "../../resources/img/icons/Checkbox@1x-black.png";

const FilterOverlay = styled(Overlay)`
width: 100%;
height: 100%;
`;

const textProps = {
	ml: 3
};


class Interests extends Component {

	state = {
		selected: []
	};

	handleSelect = (name) => {
		// const {selected} = this.props;
		const {handleUpdate, selected} = this.props;
		let contains = false;

		for (var i = selected.length - 1; i >= 0; i--) {
			if (selected[i] === name) {
				selected.splice(i, 1);
				contains = true
				// this.setState({selected})
				// break;       //<-- Uncomment  if only the first term has to be removed
			}
		}

		if (!contains) {
			selected.push(name)
			// this.setState({selected})
		}

		handleUpdate(selected)

	};

	render() {
		const {interests, selected} = this.props;
		let mySelected = []
		if(selected){
			mySelected = selected
		}
		return (
			<Overlay.Container>
				{overlay => (
					<Block>
						<Flex onClick={overlay.show} {...overlay}>
							<Box><Text ml={'7px'} fontWeight={600}>Interests</Text></Box>
							<Box mr={'auto'}/>
							<Box><Image src={chevronRight}/> </Box>
						</Flex>
						<Backdrop use={[Portal, Overlay.Hide]} {...overlay} />
						<FilterOverlay use={Portal} {...overlay}>

							<Box>
								<Text fontSize={4} onClick={overlay.hide}><Image src={chevron}/></Text>
								<Box width={1} pt={2} pb={'4px'} boxShadow={'main'}>
									<Heading>Interests</Heading>
								</Box>
								<Block>

									<Divider/>
									{interests.map(interest =>
										interest.activated ?
											<Box key={interest.id} width={1}>
												<Flex onClick={() => this.handleSelect(interest.id)}>
													<Box>
														<Text {...textProps}>{interest.name}</Text>
													</Box>
													<Box ml={'auto'}/>
													<Box pr={2}>
														{mySelected.includes(interest.id) && <Image src={check}/>}
													</Box>


												</Flex>
												<Divider/>
											</Box>
										: ""
									)}


								</Block>
							</Box>
						</FilterOverlay>
					</Block>
				)}
			</Overlay.Container>
		)
	}
}

export default Interests
